// extracted by mini-css-extract-plugin
module.exports = {"instructions":"ResetPasswordInfoComponent_instructions__3gwUN"};